import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaBars, FaTimes } from 'react-icons/fa';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const role = localStorage.getItem('role'); // Get the role from localStorage

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Define conditions for background styling (for certain pages)
  const isListingPage = location.pathname.includes('/community/');
  const isContactsPage = location.pathname.includes("/contact");
  // 

  const isBlogsPage = location.pathname.includes("/blogs");
  const isSellPage = location.pathname.includes("/sell");
  const isbuyPage = location.pathname.includes("/buy");
  const isReportsPage = location.pathname.includes("/quarterly-reports");


  // Handle user logout
  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('role');
    window.location.href = '/';
  };

  // Toggle the mobile menu open/closed
  const toggleMobileMenu = () => {
    setMobileMenuOpen(prev => !prev);
  };

  return (
    <>
      <nav
        className={`
          fixed w-full top-0 z-50 transition-colors duration-300
          ${isListingPage || isBlogsPage || isSellPage || isContactsPage || isbuyPage || isReportsPage
            ? 'bg-black'
            : (scrolled ? 'bg-black shadow-md' : 'bg-transparent')
          }
          text-white px-4 md:px-24 py-6
        `}
      >
        <div className="flex items-center justify-between w-full">
          {/* Left: Brand */}
          <div className="mr-12 leading-tight">
  <div className="text-2xl font-bold tracking-wide">Brian Karsh</div>
  <div className="text-xs font-light uppercase tracking-widest">
    Real Estate
  </div>
</div>


          {/* Desktop Navigation Links */}
          <ul className="hidden md:flex space-x-12 text-base font-medium uppercase">
            <li>
              <Link to="/" className="hover:text-gray-300 transition-colors duration-200">
                Home
              </Link>
            </li>
            {/* <li>
              <Link to="/communities" className="hover:text-gray-300 transition-colors duration-200">
                Communities
              </Link>
            </li> */}
            <li>
              <Link to="/about" className="transition-colors duration-200 hover:text-gray-300">
                About Me
              </Link>
            </li>
            <li>
              <Link to="/blogs" className="hover:text-gray-300 transition-colors duration-200">
                Blogs
              </Link>
            </li>
            <li>
              <Link to="/contact" className="hover:text-gray-300 transition-colors duration-200">
                Contact
              </Link>
            </li>
            <li>
              <Link 
              to="/quarterly-reports"
              onClick={toggleMobileMenu}
              className="hover:text-gray-300 transition-colors duration-200"
              >
              Quarterly Reports
            </Link>
            </li>
          </ul>

          {/* Desktop: Logout/SignIn */}
          <div className="hidden md:block ml-12">
            {role ? (
              <button
                onClick={handleLogout}
                className="text-white bg-red-600 hover:bg-red-700 py-2 px-4 rounded-full"
              >
                Logout
              </button>
            ) : (
              <Link
                to="/sign-in"
                className="text-white bg-blue-600 hover:bg-blue-700 py-2 px-4 rounded-full"
              >
                Sign In
              </Link>
            )}
          </div>

          {/* Mobile: Burger Icon */}
          <div className="md:hidden">
            <button onClick={toggleMobileMenu} className="focus:outline-none">
              {mobileMenuOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
            </button>
          </div>
        </div>
      </nav>

      {/* Mobile Navigation Menu (Full screen overlay) */}
      {mobileMenuOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-90 text-white z-40 flex flex-col justify-center items-center space-y-8 md:hidden">
          <ul className="text-center space-y-6 text-xl">
            <li>
              <Link
                to="/"
                onClick={toggleMobileMenu}
                className="hover:text-gray-300 transition-colors duration-200"
              >
                Home
              </Link>
            </li>
            {/* <li>
              <Link
                to="/communities"
                onClick={toggleMobileMenu}
                className="hover:text-gray-300 transition-colors duration-200"
              >
                Communities
              </Link>
            </li> */}
            <li>
              <Link
                to="/about"
                onClick={toggleMobileMenu}
                className="hover:text-gray-300 transition-colors duration-200"
              >
                About Me
              </Link>
            </li>
            <li>
              <Link
                to="/blogs"
                onClick={toggleMobileMenu}
                className="hover:text-gray-300 transition-colors duration-200"
              >
                Blogs
              </Link>
            </li>
            <li>
              <Link
                to="/contact"
                onClick={toggleMobileMenu}
                className="hover:text-gray-300 transition-colors duration-200"
              >
                Contact
              </Link>
            </li>
            <li>
              <Link 
              to="/quarterly-reports"
              onClick={toggleMobileMenu}
              className="hover:text-gray-300 transition-colors duration-200"
              >
              Quarterly Reports
            </Link>
            </li>
          </ul>
          {/* Mobile: Logout/SignIn */}
          <div className="mt-8">
            {role ? (
              <button
                onClick={() => { toggleMobileMenu(); handleLogout(); }}
                className="text-white bg-red-600 hover:bg-red-700 py-2 px-4 rounded-full"
              >
                Logout
              </button>
            ) : (
              <Link
                to="/sign-in"
                onClick={toggleMobileMenu}
                className="text-white bg-blue-600 hover:bg-blue-700 py-2 px-4 rounded-full"
              >
                Sign In
              </Link>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default Navbar;
